/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import { SHA1 } from "crypto-js";

export const login1 = async (email, password) => {
  try {
    const response = await fetch(`/cws/auth?email=${email}&userPassword=${SHA1(password).toString()}`);
    // if (!response.ok) console.log("response :", response);
    return await response.json();
  } catch (e) {
    throw e;
  }
};

export const login = async (email, password) => {
  const body = { email, userPassword: password };
  const headers = { "Content-Type": "application/json" };
  try {
    const response = await fetch(`/patientmanagement/auth`, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(body),
    });

    return await response.json();
  } catch (e) {
    throw Error("Unable to login at this time. Please try again later");
  }
};

export const verify = async (email, password, authCode) => {
  const body = { email, userPassword: password, authCode: authCode };
  const headers = { "Content-Type": "application/json" };
  try {
    const response = await fetch(`/patientmanagement/auth`, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(body),
    });
    if (!response.ok) console.log("response :", response);
    return await response.json();
  } catch (e) {
    throw e;
  }
};

export const signUp = async (email, username, password, recaptcha) => {
  const body = { email, username, password: SHA1(password).toString(), recaptcha };
  try {
    const response = await fetch(`/cfs/rest/users/signup?verify=false&lang=fa`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    return await response.json();
  } catch (e) {
    throw e;
  }
};

export const getCurrentUser = async () => {
  try {
    const lS = window.localStorage.getItem("genToken");
    const response = await fetch(`/patientmanagement/rest/users/currentUser`, {
      headers: { token: JSON.parse(lS)["token"] },
    });
    if (!response.ok) throw Error("Request Error");
    return await response.json();
  } catch (e) {
    throw e;
  }
};

export const isAuthenticated = () => {
  const token = window.localStorage.getItem("token");
  if (!token) return false;
  return true;
};
